import { render, staticRenderFns } from "./RoutingBGPRouterForm.vue?vue&type=template&id=77d8cf0a&"
import script from "./RoutingBGPRouterForm.vue?vue&type=script&lang=js&"
export * from "./RoutingBGPRouterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports